import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SiteHead from "./SiteHead";

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SiteHead />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
